export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/animated_gifs.cb79b31.svg";